var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaterTool(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 41.9,
    height: 42.1,
    viewBox: "0 0 41.9 42.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Vereinigungsmenge_15",
    x: 13.6,
    y: 0,
    width: 28.2,
    height: 33.5,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#00c4ff"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Pfad_371",
    x: 0,
    y: 0.1,
    width: 41.9,
    height: 42,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#00c4ff"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "WATTER_SUPPLY",
    "data-name": "WATTER SUPPLY",
    transform: "translate(3 3)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#Vereinigungsmenge_15)",
    transform: "matrix(1, 0, 0, 1, -3, -3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vereinigungsmenge_15-2",
    "data-name": "Vereinigungsmenge 15",
    className: "cls-1",
    d: "M4217.5-2726.9c0-1.3,2.4-4.8,2.4-4.8s2.4,3.5,2.4,4.8a2.434,2.434,0,0,1-2.4,2.4A2.433,2.433,0,0,1,4217.5-2726.9Zm-.1-6.5c.1-5,2-6.9,3.9-8.1a9.732,9.732,0,0,1,4.5-1.2h.2v-2.1h7.6v2.1h2.3v5h-2.3v1H4226v-1h-.1c-.9.1-3.4-.1-3.5,4.4Zm4.6-7.3c-1.6,1.1-3.1,2.5-3.4,6.3h3c.3-2.8,1.7-4.2,4.2-4.3h1.2v1h5.6v-1h2.3v-3h-2.3v-2.1h-5.5v2h-1.2A7.43,7.43,0,0,0,4222-2740.7Zm14.7,5.4v-10.2h2.9v10.2Zm-7.8-10.7v-2.9h-2.7a.684.684,0,0,1-.7-.7v-.4a.684.684,0,0,1,.7-.7h2.7v-.4a.9.9,0,0,1,.9-.9,1.063,1.063,0,0,1,1,.9v.5h2.7a.563.563,0,0,1,.6.7v.3a.684.684,0,0,1-.7.7h-2.7v2.9Z",
    transform: "translate(-4200.8 2755)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#Pfad_371)",
    transform: "matrix(1, 0, 0, 1, -3, -3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_371-2",
    "data-name": "Pfad 371",
    fill: "#f5f5f5",
    d: "M33.9,20.1A16.012,16.012,0,1,1,18,2.1h.1V.1H18a18,18,0,1,0,17.9,20h-2Z",
    transform: "translate(3 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaterTool);
export default __webpack_public_path__ + "static/media/water-tool.c270c4000a2ecba6c62334d5069588e2.svg";
export { ForwardRef as ReactComponent };